const ALLOWED_TYPES = [
  "apartment",
  "house",
  "land",
  "commercial",
  "industrial",
];
const ALLOWED_STATUSES = [
  "draft",
  "active",
  "reserved",
  "sold",
  "archived",
];

/** Last matching value wins — mirrors D1 `query_params.get`. */
function lastAllowed(values, allowed) {
  const matched = (values || []).filter((v) => allowed.includes(v));
  if (matched.length === 0) return "";
  return matched[matched.length - 1];
}

export function readCorporatePropertyListQuery(search) {
  const params = new URLSearchParams(search || "");
  const pageRaw = Number.parseInt(params.get("page") || "1", 10);
  const page = Number.isFinite(pageRaw) && pageRaw > 0 ? pageRaw : 1;
  const propertyType = lastAllowed(
    params.getAll("property_type"),
    ALLOWED_TYPES,
  );
  const status = lastAllowed(params.getAll("status"), ALLOWED_STATUSES);
  return {
    query: params.get("q") || "",
    propertyType,
    status,
    page,
  };
}

export function buildCorporatePropertyListParams({
  query = "",
  propertyType = "",
  status = "",
  page = 1,
  pageSize = 20,
} = {}) {
  const params = { page, page_size: pageSize };
  const trimmed = String(query || "").trim();
  if (trimmed) params.search = trimmed;
  if (propertyType && ALLOWED_TYPES.includes(propertyType)) {
    params.property_type = propertyType;
  }
  if (status && ALLOWED_STATUSES.includes(status)) params.status = status;
  return params;
}

export function writeCorporatePropertyListSearch({
  query = "",
  propertyType = "",
  status = "",
  page = 1,
} = {}) {
  const params = new URLSearchParams();
  const trimmed = String(query || "").trim();
  if (trimmed) params.set("q", trimmed);
  if (propertyType && ALLOWED_TYPES.includes(propertyType)) {
    params.set("property_type", propertyType);
  }
  if (status && ALLOWED_STATUSES.includes(status)) {
    params.set("status", status);
  }
  if (page > 1) params.set("page", String(page));
  const qs = params.toString();
  return qs ? `?${qs}` : "";
}

export { ALLOWED_TYPES as PROPERTY_FILTER_TYPES };
export { ALLOWED_STATUSES as PROPERTY_FILTER_STATUSES };
